import Service from './Service'
import moment from 'moment'

class Events extends Service {
    /** @type {Array} */
  cachedEvents

    /** @type {moment} */
  eventsCacheTime

  /** @type {Array} */
  cachedReasonCodes

  /** @type {moment} */
  reasonCodesCacheTime

  constructor (connection) {
    super(connection)
    this.cachedEvents = []
    this.eventsCacheTime = []
    this.cachedReasonCodes = []
    this.reasonCodesCacheTime = 0
  }

  createNewEvent (params) {
    params.mode = 'post'
    return this.connection.requestSpea('events', params)
      .then(response => {
        this.cachedEvents = []
        this.eventsCacheTime = 61
        return response.data
      })
      .catch(response => this.handleErrorResponse(response))
  }

  getEventsByPage (pageNo, params) {

    if (typeof params === 'undefined') params = {}

    params.reverse = 1


    params.limit = 100
    params.page = pageNo

    return this.connection.get('events/filtered', params)
      .then(response => this.handleMultiRecordResponse(response, true))
      .then(resp => {

      //this.eventsCacheTime = moment()

      return resp
    })
  }

  getEvents (params) {
    if (this.cachedEvents.length &&
        this.eventsCacheTime &&
          moment().diff(this.eventsCacheTime, 'seconds') < 60
        ) {
      return Promise.resolve(this.cachedEvents)
    }

    if (typeof params === 'undefined') params = {}
    return this.fetchAllRecords('events', params).then(response => {
      let newEvents = response.filter(event => (event.speaApiVersion))
      this.cachedEvents = newEvents
      this.eventsCacheTime = moment()
      return newEvents
    })
  }

  getEvent (id) {
    return this.connection.get('events/' + id, {})
        .then(response => {
          return response.data
        })
      .catch(response => this.handleErrorResponse(response))
  }

  deleteEvent (id) {
    return this.connection.requestSpea('events/' + id + '?withAssociations=1', {mode: 'delete'})
        .then(response => {
          this.cachedEvents = []
          this.eventsCacheTime = 61
          this.handleEmptyResponse(response)
        })
        .catch(response => this.handleErrorResponse(response))
  }

  async save (params) {
    let request = 'events/' + params.id
    params.mode = 'patch'
    return await this.connection.requestSpea(request, params)
        .then(response => {
          this.cachedEvents = []
          this.eventsCacheTime = 61
          this.handleEmptyResponse(response)
        })
        .catch(response => this.handleErrorResponse(response))
  }

  getReasonCodes () {
    if (this.cachedReasonCodes.length &&
        this.reasonCodesCacheTime &&
        moment().diff(this.reasonCodesCacheTime, 'seconds') < this.cacheTimeNormal
      ) {
      return Promise.resolve(this.cachedReasonCodes)
    }

    let params = {}
    params.request = 'getReasonCodes'
    params.recordsOnPage = 100
    params.purpose = 'PROMOTION'

    return this.fetchAllRecords('', params)
        .then(reasonCodes => {
          this.cachedReasonCodes = reasonCodes
          this.reasonCodesCacheTime = moment()
          return reasonCodes
        })
        .catch(response => this.handleErrorResponse(response))
  }
}

export default Events



// WEBPACK FOOTER //
// ./src/api/Service/Events.js